import { call, put } from 'redux-saga/effects';

import {
  getGameChangerOutputFileIdsFailure,
  getGameChangerOutputFileIdsSuccess,
} from '@actions/gameChanger';
import { listOutputFileIds } from '@api/gameChanger';
import { toastError } from '@store/notifications';

export const fetchGameChangerOutputFileIdsSaga = function* ({ payload }) {
  try {
    const response = yield call(listOutputFileIds, payload);
    yield put(getGameChangerOutputFileIdsSuccess(response));
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      getGameChangerOutputFileIdsFailure(error),
    ]);
  }
};
